import React from "react";

import { emailRegex } from "../../../constants/regex";

import styles from "./LoginForm.module.scss";

export interface LoginFormProps {
  calling: boolean;
  error: string;
  login: (email: string, password: string) => void;
}

const validates: { [key: string]: (value: any) => string } = {};

validates["email"] = val => {
  return val.email.match(emailRegex)
    ? ""
    : "正しいメールアドレスを入力してください。";
};

validates["password"] = val => {
  return val.password.length < 6 || val.password.length > 32
    ? "パスワードは6文字以上32文字以内で入力してください。"
    : "";
};

export const LoginForm = (props: LoginFormProps) => {
  const [state, setState] = React.useState({
    email: "",
    password: "",
    isSubmitted: false,
    errorMessages: {} as { [key: string]: string },
  });

  const onSubmit = React.useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      const errorMessages = {} as { [key: string]: string };
      Object.keys(validates).forEach(key => {
        const ret = validates[key](state);
        if (ret) {
          errorMessages[key] = ret;
        }
      });
      if (Object.keys(errorMessages).length > 0) {
        setState(s => ({ ...s, errorMessages }));
        return;
      }
      props.login(state.email, state.password);
    },
    [state, props],
  );

  const onChange = React.useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      e.preventDefault();
      const val = e.currentTarget.value;
      const key = e.currentTarget.name;
      const args = { [key]: val };
      const ret = validates[key](args);
      setState(prevState => ({
        ...prevState,
        [key]: val,
        errorMessages: { ...prevState.errorMessages, [key]: ret },
      }));
    },
    [],
  );

  return (
    <div className="container mt-3">
      <div className={styles.pageTitle}>
        ENAGEEDサービス学校管理者画面
        <br />
        ログインページ
      </div>
      <div className={styles.inputAreaWrapper}>
        <form
          onSubmit={onSubmit}
          className={state.isSubmitted ? "was-validated" : ""}
        >
          {props.error && (
            <div className={styles.errorBillboard}>{props.error}</div>
          )}
          <div className="mb-3">
            <label className="form-label" htmlFor="email">
              メールアドレス
            </label>
            <div className="input-group">
              <input
                type="email"
                name="email"
                className={
                  "form-control " +
                  (state.errorMessages["email"]
                    ? "is-invalid"
                    : state.email
                    ? "is-valid"
                    : "")
                }
                id="email"
                value={state.email}
                onChange={onChange}
              />
            </div>
            <div className="invalid-feedback">
              {state.errorMessages["email"]}
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="password">
              パスワード
            </label>
            <div className="input-group">
              <input
                type="password"
                id="password"
                name="password"
                className={
                  "form-control " +
                  (state.errorMessages["password"]
                    ? "is-invalid"
                    : state.password
                    ? "is-valid"
                    : "")
                }
                value={state.password}
                onChange={onChange}
              />
              <div className="invalid-feedback">
                {state.errorMessages["password"]}
              </div>
            </div>
          </div>
          <button
            className="btn btn-primary"
            onClick={onSubmit}
            disabled={
              Object.keys(state.errorMessages).filter(
                k => state.errorMessages[k],
              ).length > 0 || props.calling
            }
          >
            ログイン
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
